/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace, push } from 'react-router-redux';
import clone from 'clone';
import moment from 'moment-timezone';
import {
  Button,
  Container,
  Dimmer,
  Divider,
  Grid,
  Header,
  Icon,
  Loader,
  Message,
  Segment,
} from 'semantic-ui-react';
import { Trans, withTranslation } from 'react-i18next';

import config from '../../../../config';
// actions
import { fetchM } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
// components
import AppForm from '../../../components/AppForm';
import BookingTitle from '../../../components/Bookings/BookingTitle';
import LeadActivity from '../../../components/Bookings/LeadActivity';
import Timestamp from '../../../components/Timestamp';
// containers
import LawyerCases from '../../Lawyer/Cases';
import LoanTracker from '../../LoanTracker/LoanTracker';
// modals
import BookingStatusNotes from '../../modals/BookingStatusNotes';
// structs
import BOOKING_DEFAULT from '../../../structs/booking';
// constants
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

moment.locale('en-gb');

class Tracker extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    allBankCases: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    auth: PropTypes.shape({
      companyBranch: PropTypes.object,
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      creditCheckAccess: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
    }),
    onCheck: PropTypes.func,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        noeticIsEnabled: PropTypes.bool,
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    fetchNewBooking: PropTypes.func,
    hasDropCase: PropTypes.bool,
    isMobile: PropTypes.bool,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }).isRequired,
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = Object.assign({}, BOOKING_DEFAULT, props.data);
    const allBankCases = [].concat(props.allBankCases);
    const hasDropCase = props.hasDropCase;
    data.isCancelPending = true;
    if (!data.bankCases) {
      data.bankCases = [];
    } else if (data.bankCases && data.bankCases.length > 0) {
      const soldCases = data.bankCases.filter(bankCase => bankCase.status === 'success_li_issued');
      if (soldCases && soldCases.length > 0) {
        data.selectedBankCaseID = soldCases[0].id;
        data.bankName = soldCases[0].bank.name;
        data.bankerName = soldCases[0].banker.preferredName;
        data.loanAmount = parseInt(soldCases[0].loanAmount, 10);
      }
    }
    return {
      allBankCases,
      data,
      oriData: clone(data),
      hasDropCase,
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = Tracker.getPropsToState(props);
    this.state = {
      ...state,
      bookingStatusModal: false,
      bbfLoading: false,
    };
    this.validation = {};
    this.loanBox = null;
  }
  componentWillReceiveProps(nextProps) {
    const state = Tracker.getPropsToState(nextProps);
    let { allBankCases, hasDropCase } = this.state;
    // don't allow state to override data if oriData is same
    if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
      state.data = this.state.data;
    }
    if (JSON.stringify(this.state.allBankCases) !== JSON.stringify(state.allBankCases)) {
      allBankCases = state.allBankCases || [];
    }
    if (this.state.hasDropCase !== state.hasDropCase) {
      hasDropCase = state.hasDropCase;
    }

    this.setState({ allBankCases, hasDropCase, ...state });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading = (loading = false) => (new Promise((res) => {
    this.setState({ loading }, res);
  }))
  getPrimaryBookingCustomer = (data) => {
    if (data.bookingCustomers && data.bookingCustomers.length > 0) {
      const primaryCustomer = data.bookingCustomers.find(f => f.customerID === data.customerID);
      if (primaryCustomer) {
        return primaryCustomer;
      }
    }
    return {};
  }
  getSuccessBankCase = (data) => {
    if (data.bankCases.length > 0) {
      const soldCase = data.bankCases.find(bankCase => bankCase.status === 'success_li_issued');
      if (soldCase) {
        return soldCase;
      }
    }
    return null;
  }
  checkIsNotAuthorizedToInviteBanker = () => {
    const { auth } = this.props;
    const { data } = this.state;
    // Not allowed to invite and role is not HQ nor Super Admin
    if (data && data.project && !data.project.allowAgentSalesTeamBankerInvitation &&
      auth && !auth.isHeadquarters && !auth.isSuperAdmin) {
      return true;
    }
    return false;
  }
  async generateBankerBookingForm(xid = this.state.data.id) {
    await this.setComponentState({
      bbfLoading: true,
    });
    const { store } = this.context;
    const { t } = this.props;
    try {
      await store.dispatch(fetchM(`/bookings/${xid}/print_banker/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setComponentState({
        bbfLoading: false,
      });
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setComponentState({
      bbfLoading: false,
    });
    store.dispatch(replace(`/bookings/${this.state.data.id}/?section=tracker`));
    store.dispatch(flashSuccessMessage({
      header: t('Success', { ns: TRANSLATION_FILES.constants }),
      message: t('Booking form has been generated and shared to banker(s)', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  async updateBooking(booking) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const xid = this.state.data.id;
    const validations = await AppForm.validate(this.validation, this.state.data);
    const errMessages = validations.filter(v => !v.isValid);
    await this.setComponentState({
      errMessages,
    });
    if (errMessages.length > 0) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errMessages.map(l => l.message) }));
      return;
    }
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${xid}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(booking),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    const data = await res.json();
    await this.setLoading(false);
    this.handleResetCheck('bookingChanges');
    store.dispatch(push(`/bookings/${xid}/`));
    store.dispatch(flashSuccessMessage({
      header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Booking {{code}} successfully updated', { code: data.code, ns: TRANSLATION_FILES.translation }),
    }));
  }
  hasAccess(check = false, admin = true, dhq = true, dbl = true, internal = false) {
    const auth = this.props.auth;
    if (dbl && this.props.auth.isBranchLeader) {
      return true;
    }
    if (dhq && this.props.auth.isHeadquarters) {
      return true;
    }
    if (admin && this.props.auth.isSuperAdmin) {
      return true;
    }
    if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  
  bcfPRefix = v => `bcf_${v}`

  isCustomFieldRequiredAtStatus = (field, statusID) => {
    // Only applies to booking custom fields
    if (!field.isRequired) {
      return false;
    }

    // Status-based logic only applies to custom booking fields
    if (field.isDefault) {
      return field.isRequired;
    }

    // For CUSTOM booking fields: apply status-based logic
    const currentStatus = statusID || 'reserved';
    const requiredAtStatus = field.requiredAtStatus || 'reserved';

    // Define status hierarchy: reserved < booked < sold_spa_signed
    const statusHierarchy = {
      'reserved': 1,
      'booked': 2,
      'sold_spa_signed': 3,
    };

    const currentLevel = statusHierarchy[currentStatus];
    const requiredLevel = statusHierarchy[requiredAtStatus];

    if (!currentLevel || !requiredLevel) {
      return false;
    }

    return currentLevel >= requiredLevel;
  }

  handleBookingStatusChange = (event, value) => {
    const { data, oriData } = this.state;
    const { t } = this.props;
    const newStatusID = value.value;
    const projectBookingCustomFields = this.props.projectBookingCustomFields || [];

    if (projectBookingCustomFields && projectBookingCustomFields.length > 0) {
      const missingFields = [];
      
      projectBookingCustomFields.forEach((field) => {
        // Status-based validation only applies to custom fields
        if (field.isDefault) {
          return;
        }
        
        if (this.isCustomFieldRequiredAtStatus(field, newStatusID)) {
          const fieldValue = data[this.bcfPRefix(field.name)];
          if (!fieldValue || fieldValue === '' || (Array.isArray(fieldValue) && fieldValue.length === 0)) {
            missingFields.push(field.label);
          }
        }
      });

      if (missingFields.length > 0) {
        const { store } = this.context;
        const fieldList = missingFields.join(', ');
        store.dispatch(flashErrorMessage({
          header: t('Required Fields Missing', { ns: TRANSLATION_FILES.translation }),
          message: t('Please fill in all required fields before changing status: {{fields}}', { fields: fieldList, ns: TRANSLATION_FILES.translation }),
        }));
        return;
      }
    }

    data[value.name] = value.value;
    if (data[value.name] !== oriData[value.name]) {
      this.setState({ data, bookingStatusModal: true });
    }
  }
  handleCancelBookingStatus = () => {
    const { data, oriData } = this.state;
    data.statusID = oriData.statusID;
    data.remarkInternal = oriData.remarkInternal;
    this.setState({ data, bookingStatusModal: false });
  }
  handleCheckboxChange = (event, { checked }) => {
    const { data } = this.state;
    data.isCancelPending = checked;
    this.setState({ data });
  }
  handleConfirmBookingStatus = () => {
    const { data } = this.state;
    const booking = {
      statusID: data.statusID,
      newBookingNoteEncoded: data.newBookingNoteEncoded,
      selectedBankCaseID: data.selectedBankCaseID,
      bankName: data.bankName,
      bankerName: data.bankerName,
      loanAmount: data.loanAmount,
    };
    if (data.statusID === 'sold_spa_signed' || data.statusID === 'cancelled_developer') {
      booking.isCancelPending = data.isCancelPending;
    }
    this.setState({ bookingStatusModal: false }, () => {
      this.updateBooking(booking, 'update');
    });
  }
  handleGenerateBankerBookingForm = (e) => {
    e.preventDefault();
    this.generateBankerBookingForm();
  }
  handleNotesChange = (bnEncoded) => {
    const { data } = this.state;
    data.newBookingNoteEncoded = bnEncoded;
    data.remarkInternal = '';
    this.setState({ data });
  }
  handleResetCheck = (value, callback) => {
    const state = this.state;
    if (state[value] === true) {
      state[value] = false;
      this.setState({ [value]: state[value] }, () => {
        this.handleOnCheck(callback);
      });
    }
  }
  renderSoldCasePrompt = () => {
    const access = this.hasAccess(false, true, true, true, true);
    const { oriData } = this.state;
    const { t } = this.props;
    const soldCases = oriData.bankCases.filter(bankCase => bankCase.status === 'success_li_issued');
    if (access && oriData.statusID !== 'sold_spa_signed' && oriData.statusID !== 'expired' && oriData.statusID !== 'cancelled_developer' && oriData.statusID !== 'cancelled_availability' && soldCases.length > 0) {
      const bankerName = soldCases[0].banker.preferredName;
      const bankName = soldCases[0].bank.name;
      return (
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Message warning>
                <Grid columns="equal" verticalAlign="middle">
                  <Grid.Column mobile={9} tablet={12} computer={12}>
                    <Trans ns={TRANSLATION_FILES.screens}>
                      <strong>{{ bankerName }}</strong> from <strong>{{ bankName }}</strong> has updated Loan Status to <strong>LO Signed</strong>.
                    </Trans>
                  </Grid.Column>
                  <Grid.Column mobile={7} tablet={4} computer={4} textAlign="right">
                    <Button
                      size="small"
                      positive
                      onClick={e => this.handleBookingStatusChange(e, { name: 'statusID', value: 'sold_spa_signed' })}
                      content={t('Mark Sold')}
                    />
                  </Grid.Column>
                </Grid>
              </Message>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }
    return null;
  }
  refreshBankingData = async () => {
    const { data } = this.state;
    if (data && data.id) {
      try {
        await this.setLoading(true);
        const { store } = this.context;
        const res = await store.dispatch(fetchM(`/bookings/${data.id}/`, {
          credentials: 'include',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': this.props.token,
          },
        }));
        if (res.ok) {
          const updatedData = await res.json();
          this.setState({
            data: updatedData,
            oriData: clone(updatedData),
          });
        }
      } finally {
        await this.setLoading(false);
      }
    }
  };
  handleBankerAssignmentSuccess = async () => {
    const { data } = this.state;
    if (this.props.fetchNewBooking) {
      await this.props.fetchNewBooking();
    }
    if (data && data.project && data.project.autoShareFormToBanker) {
      this.generateBankerBookingForm(this.state.data.id);
    }
  }
  render() {
    const {
      allBankCases,
      bbfLoading,
      bookingStatusModal,
      data,
      hasDropCase,
      oriData,
    } = this.state;
    const { t } = this.props;
    const primaryCustomer = this.getPrimaryBookingCustomer(data);
    const successBankCase = this.getSuccessBankCase(data);
    return (
      <Container className="no_margin">
        <BookingStatusNotes
          isCancelPending={data.isCancelPending}
          notes={data.remarkInternal}
          onCheckboxChange={this.handleCheckboxChange}
          onClose={this.handleCancelBookingStatus}
          onConfirm={this.handleConfirmBookingStatus}
          onNotesChange={this.handleNotesChange}
          open={bookingStatusModal}
          statusID={data.statusID}
          data={data}
        />
        <BookingTitle isMobile={this.props.isMobile} data={data} />
        {this.renderSoldCasePrompt()}
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16} textAlign="center">
              <Header className="new_title" as="h5" attached="top">
                {t('Loan').toUpperCase()}
              </Header>
              <Segment attached>
                {
                  !data.buyerProfileID ? (
                    <div>
                      <Divider horizontal id="loanBox">
                        {
                          data.loanTrackerLeadCode && !config.get('mhubLoader') ? (
                            <a
                              href={`${config.get('loanTrackerURL')}/deals/${data.loanTrackerLeadCode}/`}
                              rel="noopener noreferrer"
                              target={config.get('server') === 'staging' ? '_self' : '_blank'}
                            >
                              {t('Refer To Mortgage Banker')}
                              <Icon name="linkify" />
                            </a>
                          ) : t('Refer To Mortgage Banker')
                        }
                      </Divider>
                      {
                        oriData.statusID === 'sold_spa_signed' || oriData.statusID === 'cancelled_developer' || oriData.statusID === 'cancelled_availability' ?
                          null
                          : (<p>{t('Help purchasers kickstart the loan application process in 3 easy steps')}.</p>)
                      }
                      {(data.loanTrackerLeadCode !== '' && data.bankCases.length > 0) ?
                        <Button
                          compact
                          icon
                          onClick={this.handleGenerateBankerBookingForm}
                          size="small"
                          disabled={(data.pdfFileKey !== '' && !(moment(data.updatedAt) > moment(data.pdfLastSentAt))) || data.project.printType === ''}
                        >
                          {t(bbfLoading ? 'Generating Banker(s) Booking Form' : 'Share Booking Form to Banker(s)')} <Icon loading={bbfLoading} name={bbfLoading ? 'spinner' : 'external share'} />
                        </Button>
                        : ''
                      }
                      {(data.loanTrackerLeadCode !== '' && data.bankCases.length > 0 && data.pdfFileKey !== '') ?
                        <div style={{ marginBottom: '1.6em' }}><small>{t('Last shared at')} <Timestamp format="MMMM Do YYYY, h:mm a" timestamp={data.pdfLastSentAt} /></small></div>
                        : <div style={{ minHeight: '1.8em' }} />
                      }
                      <LoanTracker
                        auth={this.props.auth}
                        project={data.project}
                        allBankCases={allBankCases}
                        bankCases={data.bankCases}
                        bankerSelectionTabs={data.project && data.project.bankerSelectionTabs ? data.project.bankerSelectionTabs : []}
                        bookingID={data.id}
                        bookingStatusID={oriData.statusID}
                        bookingSPAValue={data.spaValue}
                        consentTypeID={data.project ? data.project.loanTrackerProjectConsentTypeID : null}
                        disabled={oriData.statusID === 'sold_spa_signed' ||
                          oriData.statusID === 'cancelled_developer' ||
                          oriData.statusID === 'expired' ||
                          oriData.statusID === 'cancelled_availability'}
                        hasDropCase={hasDropCase}
                        hasSuccessBankCase={successBankCase !== null}
                        isCashBuyer={data.paymentMethodID === 'cash'}
                        isNotAuthorizedToInviteBanker={this.checkIsNotAuthorizedToInviteBanker()}
                        leadBankersLimit={data.project ? data.project.loanTrackerProjectLeadBankersLimit : 0}
                        leadStatus={data.leadStatus}
                        loanTrackerLeadCode={data.loanTrackerLeadCode}
                        loanTrackerLeadConsentPinCount={data.loanTrackerLeadConsentPinCount}
                        loanTrackerLeadConsentPinExpiresAt={data.loanTrackerLeadConsentPinExpiresAt}
                        loanTrackerLeadDropID={data.loanTrackerLeadDropID}
                        loanTrackerLeadID={data.loanTrackerLeadID}
                        location={this.props.location}
                        mobile={primaryCustomer ? primaryCustomer.mobile : null}
                        mobilePrefix={primaryCustomer ? primaryCustomer.mobilePrefix : null}
                        preferredName={primaryCustomer ? primaryCustomer.preferredName : null}
                        projectAssignBankCasesStatus={data.project ? data.project.autoAssignBankerStatus : ''}
                        projectCurrencies={data.project ? data.project.projectCurrency : ''}
                        projectID={data.projectID}
                        setLoading={this.setLoading}
                        token={this.props.token}
                        onBankerAssignmentSuccess={this.handleBankerAssignmentSuccess}
                      />
                    </div>
                  ) : null
                }

                <LeadActivity
                  data={data.leadActivities}
                  bankCases={data.bankCases}
                  leadCode={data.loanTrackerLeadCode}
                  bookingID={data.id}
                  token={this.props.token}
                  fetchNewBooking={this.props.fetchNewBooking}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          {
            this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled && (
              <Grid.Row>
                <Grid.Column width={16} textAlign="center">
                  <LawyerCases
                    bookingID={data.id}
                    data={data}
                    disabled={this.state.loading}
                    loanTrackerProjectID={data.project ? data.project.loanTrackerProjectID : 0}
                    purchasers={data.bookingCustomers}
                    primaryPurchaser={primaryCustomer}
                    setLoading={this.setLoading}
                    successBankCase={successBankCase}
                    isProjectHimsEnabled={data.project ? data.project.himsIsEnabled : false}
                    token={this.props.token}
                  />
                </Grid.Column>
              </Grid.Row>
            )
          }
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Tracker.mapStateToProps)(Tracker));



// WEBPACK FOOTER //
// ./src/containers/Bookings/Overview/Tracker.jsx